import { useQuery } from '@tanstack/react-query';

import { AUTH_CACHE_KEYS } from '@/features/authorization/constants/cache';
import { KEYCLOAK_USER_INFO_URL } from '@/features/authorization/constants/keycloak';
import { useAuthStore } from '@/features/authorization/store/useAuthStore';
import type { KeycloakProfile } from '@/features/authorization/types/keycloak';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetKeycloakProfile = () => {
  const hasToken: boolean = !isEmptyOrNull(
    useAuthStore.getState().token?.accessToken
  );

  return useQuery({
    queryKey: [AUTH_CACHE_KEYS.KEYCLOAK_PROFILE],
    queryFn: async () => {
      const token = useAuthStore.getState().token?.accessToken;
      const response = await fetch(KEYCLOAK_USER_INFO_URL, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const keycloakProfile = (await response.json()) as KeycloakProfile;
      return keycloakProfile;
    },
    retry: 2,
    enabled: hasToken,
    // The access token changes regularly. Therefore, requests with the old token can be cleared immediately.
    gcTime: 0
  });
};
